import {
  revenueByMarket,
  revenueGroupedByMarket,
  revenueSnapshotKeys,
  TRevenueSnapshots,
} from 'legacy/lut/classes/models/partner360/ELT/IELTFinancialData'
import { IRevenue } from 'legacy/lut/classes/models/partner360/ELT/IELTFormData'
import { getPostfixByActualsValueType } from 'legacy/lut/components/widgets/public/partner360/ELT/helpers/getPostfixByActualsValueType'

import { ActualsValueTypes } from 'partner360/models/actualValueTypes'

import { REVENUE_TYPES } from '../../../enums/REVENUE_TYPES'

import { formRevenueDataFromFinancialData } from './formRevenueDataFromFinancialData'
import { getRevenueItemName } from './getRevenueItemName'

const revenueValueFields = [
  'YoY',
  'CurrentYearRevenue',
  'PreviousYearRevenue',
  'CurrentYearQuarter1',
  'CurrentYearQuarter2',
  'CurrentYearQuarter3',
  'CurrentYearQuarter4',
  'PrevYearQuarter1',
  'PrevYearQuarter2',
  'PrevYearQuarter3',
  'PrevYearQuarter4',
  'TwoYearsAgo',
  'ThreeYearsAgo',
]

const getInitialRevenueValueFields = (actualValueTypes: ActualsValueTypes[]): Partial<IRevenue> => {
  return actualValueTypes.reduce<Partial<IRevenue>>((acc, valueType) => {
    const postfix = getPostfixByActualsValueType(valueType)

    return revenueValueFields.reduce<Partial<IRevenue>>((fieldAcc, field) => {
      const key = `${field}${postfix}` as keyof IRevenue
      const isYoyField = field === 'YoY'

      return {
        ...fieldAcc,
        [key]: isYoyField ? null : 0,
      }
    }, acc)
  }, {})
}

export const getRevenueInitialData = (
  initialData?: TRevenueSnapshots | null,
  markets?: string[],
  actualValueTypes: ActualsValueTypes[] = []
): IRevenue[] => {
  if (!initialData) {
    return revenueSnapshotKeys
      .filter((key) => {
        if (!revenueByMarket.includes(key)) {
          return true
        }

        if (markets && markets.length > 0) {
          return markets.some((market) => revenueGroupedByMarket[market].includes(key))
        }

        return true
      })
      .map(
        (key) =>
          ({
            Name: getRevenueItemName(key),
            Key: key,
            ...getInitialRevenueValueFields(actualValueTypes),
          }) as IRevenue
      )
  }

  return formRevenueDataFromFinancialData(
    initialData,
    REVENUE_TYPES.SellThru,
    markets,
    actualValueTypes
  )
}
